import { createClient } from '@/shared/api';
import type {
  CreateUnreviewedReportMutation,
  CreateUnreviewedReportMutationVariables,
} from '@/shared/api';
import CREATE_UNREVIEWED_REPORT from '../mutations/createUnreviewedReport';

/**
 * Creates an unreviewed report entry. Runs the createUnreviewedReport mutation and returns its payload without inspecting the success flag.
 *
 * @param input - Mutation input describing the report to create.
 * @returns A promise resolving to the createUnreviewedReport payload.
 */
const handleCreateUnreviewedReport = async (
  input: CreateUnreviewedReportMutationVariables['input'],
): Promise<CreateUnreviewedReportMutation['createUnreviewedReport'] | undefined> => {
  const client = createClient();
  const result = await client.mutate<
    CreateUnreviewedReportMutation,
    CreateUnreviewedReportMutationVariables
  >({
    mutation: CREATE_UNREVIEWED_REPORT,
    variables: {
      input,
    },
  });
  return result?.data?.createUnreviewedReport;
};

export default handleCreateUnreviewedReport;
